import InvestorVerifyFormModal from './InvestorVerifyFormModal.component';

export default InvestorVerifyFormModal;
